var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 225,
    viewBox: "0 0 189 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 210.928C146.691 210.928 189 168.651 189 116.5C189 64.349 146.691 22.0723 94.5 22.0723C42.3091 22.0723 0 64.349 0 116.5C0 168.651 42.3091 210.928 94.5 210.928Z",
    fill: "#EEF4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#new_chat_filter0_d_218_4978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.68 76.2109H40.3195C36.8401 76.2109 34.0195 79.0294 34.0195 82.5061V214.705C34.0195 218.182 36.8401 221 40.3195 221H148.68C152.159 221 154.98 218.182 154.98 214.705V82.5061C154.98 79.0294 152.159 76.2109 148.68 76.2109Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9004 95.0957H49.1404C47.0527 95.0957 45.3604 96.7868 45.3604 98.8728C45.3604 100.959 47.0527 102.65 49.1404 102.65H81.9004C83.988 102.65 85.6804 100.959 85.6804 98.8728C85.6804 96.7868 83.988 95.0957 81.9004 95.0957Z",
    fill: "#B2CCF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.58 111.463H49.1404C47.0527 111.463 45.3604 113.154 45.3604 115.24C45.3604 117.326 47.0527 119.017 49.1404 119.017H104.58C106.668 119.017 108.36 117.326 108.36 115.24C108.36 113.154 106.668 111.463 104.58 111.463Z",
    fill: "#D9E5FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9004 129.09H49.1404C47.0527 129.09 45.3604 130.781 45.3604 132.867C45.3604 134.953 47.0527 136.644 49.1404 136.644H81.9004C83.988 136.644 85.6804 134.953 85.6804 132.867C85.6804 130.781 83.988 129.09 81.9004 129.09Z",
    fill: "#B2CCF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.58 145.457H49.1404C47.0527 145.457 45.3604 147.148 45.3604 149.234C45.3604 151.32 47.0527 153.011 49.1404 153.011H104.58C106.668 153.011 108.36 151.32 108.36 149.234C108.36 147.148 106.668 145.457 104.58 145.457Z",
    fill: "#D9E5FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9004 163.084H49.1404C47.0527 163.084 45.3604 164.775 45.3604 166.861C45.3604 168.947 47.0527 170.638 49.1404 170.638H81.9004C83.988 170.638 85.6804 168.947 85.6804 166.861C85.6804 164.775 83.988 163.084 81.9004 163.084Z",
    fill: "#B2CCF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.58 179.451H49.1404C47.0527 179.451 45.3604 181.142 45.3604 183.228C45.3604 185.314 47.0527 187.005 49.1404 187.005H104.58C106.668 187.005 108.36 185.314 108.36 183.228C108.36 181.142 106.668 179.451 104.58 179.451Z",
    fill: "#D9E5FA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#new_chat_filter1_d_218_4978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.681 12H40.3205C36.8411 12 34.0205 14.8184 34.0205 18.2952V56.0663C34.0205 59.543 36.8411 62.3614 40.3205 62.3614H148.681C152.16 62.3614 154.981 59.543 154.981 56.0663V18.2952C154.981 14.8184 152.16 12 148.681 12Z",
    fill: "#9FBFF2"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9004 25.8496H49.1404C47.0527 25.8496 45.3604 27.5407 45.3604 29.6267C45.3604 31.7128 47.0527 33.4038 49.1404 33.4038H81.9004C83.988 33.4038 85.6804 31.7128 85.6804 29.6267C85.6804 27.5407 83.988 25.8496 81.9004 25.8496Z",
    fill: "#B4DAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.58 42.2168H49.1404C47.0527 42.2168 45.3604 43.9079 45.3604 45.9939C45.3604 48.0799 47.0527 49.771 49.1404 49.771H104.58C106.668 49.771 108.36 48.0799 108.36 45.9939C108.36 43.9079 106.668 42.2168 104.58 42.2168Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "new_chat_filter0_d_218_4978",
    x: 26.4653,
    y: 64.8796,
    width: 136.068,
    height: 159.897,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.77711
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.77711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_218_4978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_218_4978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "new_chat_filter1_d_218_4978",
    x: 26.4663,
    y: 0.668674,
    width: 136.068,
    height: 65.4698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.77711
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.77711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_218_4978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_218_4978",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/new-chat.a0348359857153d4e950b39a9132bc36.svg";
export { ForwardRef as ReactComponent };